import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const CheckboxCheckedIcon: FC<IProps> = ({ width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none">
    <rect
      x="0.75" y="0.75" width="18.5" height="18.5"
      rx="3.25" fill="#F9EED5" stroke="#FEC20B" strokeWidth="1.5"
    />
    <path
      d="M6 10L9 13L14 7" stroke="#262626"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

export default CheckboxCheckedIcon;
